module.exports = __webpack_public_path__ + "static/media/Rebecca.969c7601.png";